/**
 * Sets window-level properties so the embedded chat iframe can read them
 * via window.parent.* from widget_init.js.
 *
 * @param {Object} userInfo - User info object from App state
 * @param {string|null} ticketId - Optional UR ticket ID from VA escalation
 * @param {string|null} sysId - Optional sys_id of the interaction ticket
 */
export const setChatWindowProperties = (userInfo, ticketId, sysId) => {
  if (!userInfo) return;

  window.firstName = userInfo.userGivenName;
  window.lastName = userInfo.userFamilyName;
  window.userEmail = userInfo.userEmail;
  window.loginName = userInfo.userNTID;
  window.homeOUName = userInfo.userLocation;
  window.langcode = userInfo.userLanguage;
  window.genesysUrl = process.env.REACT_APP_GENESYS_URL;
  window.UniqueID = ticketId || null;
  window.ticketSysId = sysId || null;
  window.tierLevel = null;
  window.topic = null;
};

/**
 * Checks if the current URL hash contains the openChat flag.
 * Expected format: #openChat=true or #openChat=true&ticketId=UR000123
 *
 * @returns {boolean}
 */
export const hasOpenChatFlag = () => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.replace('#', ''));
  return params.get('openChat') === 'true';
};

/**
 * Extracts the ticketId from the URL hash fragment.
 * Expected format: #openChat=true&ticketId=UR000123
 *
 * @returns {string|null}
 */
export const getTicketIdFromHash = () => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.replace('#', ''));
  return params.get('ticketId') || null;
};

/**
 * Extracts the sysId from the URL hash fragment.
 * Expected format: #openChat=true&ticketId=UR000123&sysId=abc123
 *
 * @returns {string|null}
 */
export const getSysIdFromHash = () => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.replace('#', ''));
  return params.get('sysId') || null;
};

/**
 * Removes the hash fragment from the URL without triggering a page reload.
 */
export const clearOpenChatFlag = () => {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
};
